import styled from 'styled-components';

export const CustomHeader = styled.div`
  font-size: 11px;
  color: #748aa1;
  font-weight: 400;
  line-height: 16px;
  align-items: center;
  background: #fff;
`;

export const PopoverContainer = styled.div`
  padding: 10px;
  min-width: 46em;
  height: 35em;
  overflow-y: scroll;
`;

export const CenteredContainer = styled.div`
  display: grid;
  place-content: center;
`;

export const LeftCenteredContainer = styled.div`
  display: flex;
  align-items: center;
`;
